<section class="screening__card">
	<p class="screening__account-eyebrow">
		<span aria-hidden="true">4</span>
		{{ 'Screening.Pilot.Platform.Eyebrow' | translateUnauthenticated }}
	</p>
	<section class="screening__account-intro">
		<div class="screening__account-heading">
			<h3>{{ 'Screening.Pilot.Platform.Title' | translateUnauthenticated }}</h3>
			<strong>{{ 'Screening.Pilot.Platform.Badge' | translateUnauthenticated }}</strong>
		</div>
		<p>{{ 'Screening.Pilot.Platform.Lead' | translateUnauthenticated }}</p>
	</section>
	<ul class="screening__account-benefits">
		<li>
			<span class="screening__account-icon">
				<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
			</span>
			<div>
				<h4>{{ 'Screening.Pilot.Platform.Benefit.1.Title' | translateUnauthenticated }}</h4>
				<p>{{ 'Screening.Pilot.Platform.Benefit.1.Text' | translateUnauthenticated }}</p>
			</div>
		</li>
		<li>
			<span class="screening__account-icon">
				<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z"></path><path d="M8 7h8M8 11h6"></path></svg>
			</span>
			<div>
				<h4>{{ 'Screening.Pilot.Platform.Benefit.2.Title' | translateUnauthenticated }}</h4>
				<p>{{ 'Screening.Pilot.Platform.Benefit.2.Text' | translateUnauthenticated }}</p>
			</div>
		</li>
		<li>
			<span class="screening__account-icon">
				<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3v18h18"></path><path d="M7 15l4-4 3 3 5-6"></path></svg>
			</span>
			<div>
				<h4>{{ 'Screening.Pilot.Platform.Benefit.3.Title' | translateUnauthenticated }}</h4>
				<p>{{ 'Screening.Pilot.Platform.Benefit.3.Text' | translateUnauthenticated }}</p>
			</div>
		</li>
	</ul>
	<div class="screening__account-trust">
		<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path></svg>
		<span>{{ 'Screening.Pilot.Platform.Trust' | translateUnauthenticated }}</span>
	</div>
	<div class="screening__account-actions">
		<button class="c-button c-button--s12 screening__result-button" (click)="register.emit()">{{ 'Screening.Pilot.Platform.Register' | translateUnauthenticated }}</button>
		<button class="c-button c-button--link screening__result-link" (click)="login.emit()">{{ 'Screening.Pilot.Platform.Login' | translateUnauthenticated }}</button>
	</div>
	<div class="screening__account-foot">
		<span>{{ 'Screening.Pilot.Platform.SkipPrompt' | translateUnauthenticated }}</span>
		<button type="button" class="c-button c-button--link screening__result-link" (click)="skip.emit()">{{ 'Screening.Pilot.Platform.Skip' | translateUnauthenticated }}</button>
	</div>
</section>
